export const toShortcut = (text: string) =>
  text.replaceAll(" ", "").toLowerCase();
